import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import {
  ConfigurationProfile,
  configurationProfileSchema,
} from '../schemas/configuration-profile.schema';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Creates Configuration Profiles
 * @param configurationProfiles The Configuration Profiles being created
 * @returns Data Object containing the created Configuration Profiles
 */
export function postConfigurationProfiles(
  this: unknown,
  configurationProfiles: Partial<ConfigurationProfile>[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).configurationProfilesUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(configurationProfiles),
      })
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(configurationProfileSchema),
      })
    )
  );
}
